import useMutationApi from 'src/api/useMutationApi';

interface ApiResponse {
  success: boolean;
}

interface Params {
  customerId?: string;
  unitVariationId?: string;
  suggestedQuantity?: number;
}

const useQueueUpReceivedPOEvent = (onSuccess?: () => void) => {
  return useMutationApi<Params | void, ApiResponse>({
    endpoint: 'qa/queue-up-received-po-event',
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useQueueUpReceivedPOEvent;
